export default __webpack_public_path__ + "static/media/WCELO.4fb27e3a.svg";